import React from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import Question from '../Recording/Question';

const ScreenRecordingQuestion = props => {
  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);

  const screenRecordingConfig = {
    screenRecord: true,
    audio: true,
    webCam: false,
    resolution: '1080',
    tabRecording: false,
    separateLayer: false,
    fromPopup: true,
    initiator: 'generic_embed',
  };

  return (
    <Question
      {...props}
      hasZiggeoForAllMedia={hasZiggeoForAllMedia}
      recordingConfig={screenRecordingConfig}
    />
  );
};

export default props => <ScreenRecordingQuestion {...props} />;
